export enum ImporterState {
  idle,
  fileUploading,
  fileUploaded,
  fileImporting,
  fileImported,
  fileAggregating,
  fileAggregated
}
